import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { localize } from '../../translations';
import { MAIN_CARD_STATIC_TITLE } from '../../translations/constants';


const mapStateToProps = state => {
  return {   
    lang: state.common.lang || 'lv'
  }};

const mapDispatchToProps = dispatch => ({    
});

const MainView = props => {
    return (
        <div>
            <div className="row" >
                <div id="main-card-static" className="nav-object-static col-md-6" >
                    <h2> {localize(MAIN_CARD_STATIC_TITLE)} </h2>
                    <ul className="text-list" >
                        <li> Kapu labiekārtošana </li>
                        <li> Izgatavošana, uzstādīšana </li>
                        <li> Seno pieminekļu atjaunošana un tīrīšana </li>
                        <li> Izbraucam uz kapiem un konsultējam </li>
                        <li> Piegāde visā Latvijā! </li>
                    </ul>
                </div>                
                <Link id="monuments-main-card" className="nav-object col-md-6" to="/monuments">
                    <h2 > Pieminekļi un piemiņas plāksnes </h2>
                </Link>
            </div>

            <div className="row" >
                <Link id="borders-main-card" className="nav-object col-md-6" to="/borders">
                    <h2 > Apmales </h2>
                </Link>
                <Link id="outerborders-main-card" className="nav-object col-md-6" to="/outerborders">
                    <h2 > Laukumi </h2>
                </Link>
            </div>
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(MainView);


// WEBPACK FOOTER //
// ./src/components/Home/MainView.js